import React from 'react'

import {Modal, ModalHeader, ModalBody} from 'reactstrap';


export default function MDBModal({title, show, dismiss, size="xl", children}) {

    return (
        <Modal 
            isOpen={show} 
            toggle={dismiss} 
            size={size}
            backdrop="static"
        >
            <ModalHeader toggle={dismiss}>
                <span className="h2">{title}</span>
            </ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
        </Modal>
    );
}

